import { PlusIcon } from 'lucide-react'
import { useState } from 'react'

import { Dialog, DialogContent, DialogTrigger } from '@/_components/ui/dialog'

import { Button } from '../../../_components/ui/button'
import { CreateCompanyDialog } from './create-company-dialog'

export const CreateCompanyButton = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button size="xs" className="flex items-center gap-1 font-bold text-brand-grayscale-1">
          <PlusIcon size={16} />
          Nova instituição
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-[640px] p-5">
        <CreateCompanyDialog setIsDialogOpen={setIsDialogOpen} />
      </DialogContent>
    </Dialog>
  )
}
